import { Button, Flex, Group, Modal, Text } from "@mantine/core";

interface confirmCancelRecordProps {
  openedModal: boolean;
  setOpenedModal: (value: boolean) => void;
  onCancel: () => void;
}
const ConfirmCancelRecordDialog = ({
  openedModal,
  setOpenedModal,
  onCancel
}: confirmCancelRecordProps) => {
  return (
    <Modal
      opened={openedModal}
      onClose={() => setOpenedModal(false)}
      closeOnClickOutside={false}
    >
      <Flex ta={"center"} justify={"center"} direction={"column"}>
        <Text>Are you sure you want delete this recording?</Text>
        <Text>It will be permanently deleted and cannot be recovered.</Text>
      </Flex>
      <Group mt="md" justify="center">
        <Button variant="default" onClick={() => setOpenedModal(false)}>
          Cancel
        </Button>
        <Button
          color="red"
          onClick={() => {
            setOpenedModal(false);
            onCancel();
          }}
        >
          Delete
        </Button>
      </Group>
    </Modal>
  );
};
export default ConfirmCancelRecordDialog;
